<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-09-18 11:20:54
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-07-09 10:34:08
-->
<template>
	<span>
		<!-- 批量发货 -->
		<el-dialog title="批量发货" :visible.sync="visible" show-close>
			<div class="import-content mt-24">
				<el-steps :active="4" align-center>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">下载模板</div>
						<div slot="description">
							<p class="desc">待填内容包括订单号、快递公司与快递单号</p>
							<a :href="mainOrderUrl" target="_blank" class="link">下载批量导入模板</a>
						</div>
					</el-step>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">填写发货信息</div>
						<div slot="description">
							<p class="desc">在下载的表格中填写物流公司与物流单号</p>
							<a :href="companyXlsxUrl" target="_blank" class="link">下载快递公司列表</a>
						</div>
					</el-step>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">导入</div>
						<div slot="description">
							<p class="desc">将填写好的表格导入到平台</p>
						</div>
					</el-step>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">修改</div>
						<div slot="description">
							<p class="desc">导入失败的订单请修改后重新上传</p>
						</div>
					</el-step>
				</el-steps>
			</div>
			<span slot="footer">
				<upload-file accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @upload="importOrder">
					<el-button type="primary">批量导入发货信息</el-button>
				</upload-file>
			</span>
		</el-dialog>
		<!-- 批量导入结果弹窗 -->
		<el-dialog title="批量导入结果" :visible.sync="resultDialogVisble" width="400px" show-close>
			<div class="result-content">
				<p>
					表格上传成功， 任务执行中， 查看进度前往
					<el-button type="text" @click="handleOpenSampleRecord" :loading="loading">【导入记录】</el-button>
				</p>
			</div>
			<span slot="footer">
				<el-button type="primary" @click="resultDialogVisble = false">确认</el-button>
			</span>
		</el-dialog>
	</span>
</template>

<script>
import { batchSend, batchFail, getCompanyXlsxUrl } from '@/api/cooperationProgress';
import UploadFile from '@/components/common/UploadFile';
export default {
	name: 'ExportOrder',
	components: {
		UploadFile,
	},
	data() {
		return {
			visible: false,
			resultDialogVisble: false,
			importResult: {
				status: '',
				success_num: '',
				fail_num: '',
			},
			loading: false,
			mainOrderUrl: '',
			companyXlsxUrl: '',
		};
	},
	methods: {
		async getCompanyXlsxUrl() {
			try {
				const { batchSendXlsxUrl, companyXlsxUrl } = await getCompanyXlsxUrl();
				this.companyXlsxUrl = companyXlsxUrl;
				this.mainOrderUrl = batchSendXlsxUrl;
			} catch (error) {
				console.log(error);
			}
		},
		importInit(row) {
			this.getCompanyXlsxUrl();
			this.visible = true;
		},
		async importOrder(data) {
			try {
				const res = await batchSend(data);
				if (res?.code == 0) {
					this.visible = false;
					this.resultDialogVisble = true;
				}
			} catch (error) {
				console.log(error);
			}
		},
		handleOpenSampleRecord() {
			const handLink = this.$router.resolve({
				path: '/sample/importLog',
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.import-content {
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
	.link {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #ee0a24;
		line-height: 18px;
	}
}
.result-content {
	.link {
		color: #1890ff;
	}
}
/deep/.el-dialog__footer .link {
	margin-right: 10px;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #1890ff;
	line-height: 18px;
}
</style>
